import React, { ReactNode } from 'react';
import { Box, Cell } from '@wix/design-system';

export interface EntityPageAdditionalContentProps {
  /**
   * Applies a data-hook HTML attribute that can be used in tests
   */
  dataHook?: string;
  children?: ReactNode;
}

export function EntityPageAdditionalContent(
  props: EntityPageAdditionalContentProps,
) {
  const { children, ...rest } = props;
  return (
    <Cell span={4} {...rest}>
      <Box direction="vertical" gap="SP4">
        {children}
      </Box>
    </Cell>
  );
}

EntityPageAdditionalContent.displayName = 'EntityPageAdditionalContent';
